// src/components/blood/RangeSourceTag.tsx
import React from "react";
import { Tag } from "antd";

import { RangeSource } from "../../utils/geneCodes/referenceRange";

interface RangeSourceTagProps {
	source: RangeSource | undefined;
	labFlag?: string | null;
	style?: React.CSSProperties;
}

export const LAB_RANGE_LABEL = "lab range";
export const LAB_CRITICAL_LABEL = "Lab flagged critical";

// Nothing renders for a platform range: the platform band is the default, the lab's is the exception worth naming
const RangeSourceTag: React.FC<RangeSourceTagProps> = ({ source, labFlag, style }) => {
	const isLab = source === "lab";
	const labCritical = labFlag === "C";
	if (!isLab && !labCritical) return null;

	return (
		<>
			{isLab && (
				<Tag style={{ fontSize: 9, lineHeight: "14px", margin: 0, ...style }} title="No platform reference range for this analyte — showing the lab's printed range">
					{LAB_RANGE_LABEL}
				</Tag>
			)}
			{labCritical && (
				<Tag color="error" style={{ fontSize: 9, lineHeight: "14px", margin: 0, ...style }} title="The lab flagged this result critical on its own range">
					{LAB_CRITICAL_LABEL}
				</Tag>
			)}
		</>
	);
};

export default RangeSourceTag;
